module.exports = __webpack_public_path__ + "img/hcdl_main1.1380cbbb.jpg";